/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * The types for widgets
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.1
 */
import { IAction, IActionWithPayload } from '@modules/app/createAction';

import {
    LOAD_WIDGET_META,
    LOAD_WIDGET_META_FAILED,
    LOAD_WIDGET_META_SUCCESSFUL,
} from './constants/widgetActionConstants';

export enum EWidgetNames {
	COSTS = 'expenses',
	MULTI_BALANCES = 'multiBalances',
	ORDERS_INQUIRIES = 'ordersAndInquiries',
	PAYMENT_HISTORY = 'payments',
	PERSONAL_ACCOUNT = 'accountBalance',
	SEARCH_ACCOUNTS = 'account',
	SUBSCRIBERS_MAX_COSTS = 'mostSpendingSubscribers',
	SUBSCRIBER_MOBILE = 'mobileSubscribers',
	USEFUL_LINKS = 'usefulLinks',
	VOTING = 'survey',
	REPORTS_CONSTRUCTOR = 'reportsConstructor',
}

export enum EWidgetCommonStatus {
    ERROR = 'error',
    SUCCESS = 'success',
}

export enum EWidgetStatus {
    EMPTY = 'empty',
    ERROR = 'error',
    SUCCESS = 'success',
}

export type WidgetColumnType = 0 | 1 | 2;

export interface IWidgetShowFields {
    id: boolean;
    number: boolean;
    region: boolean;
    balance: boolean;
    subsCount: boolean;
    name: boolean;
    inn: boolean;
}

export interface IWidgetMetaAccountInfo {
    id: number;
    number: string;
    region: string;
}

export interface IWidgetMetaItem {
    name: EWidgetNames;
    baseAccountInfo?: IWidgetMetaAccountInfo;
    showFields?: IWidgetShowFields;
}

export type TWidgetMetaList = IWidgetMetaItem[];

export interface IWidgetStyled {
    error?: string;
    isEmpty?: boolean;
    isLoading?: boolean;
}

export interface IWidgetReducerState {
    emptyWidgets: boolean;
    error: string;
    widgetMeta: TWidgetMetaList;
}

/*
* -------------------------------------------
*                LOAD WIDGET META
* -------------------------------------------
*/

export type TLoadWidgetMetaAction = IAction<typeof LOAD_WIDGET_META>;

export type TLoadWidgetMetaSuccessfulAction = IActionWithPayload<typeof LOAD_WIDGET_META_SUCCESSFUL, TWidgetMetaList>;

export type TLoadWidgetMetaFailedAction = IActionWithPayload<typeof LOAD_WIDGET_META_FAILED, string>;

export type TWidgetActionsType =
    TLoadWidgetMetaAction
    | TLoadWidgetMetaFailedAction
    | TLoadWidgetMetaSuccessfulAction
    ;
